import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import FormGenerator from "../../core/form-generator";
import { handleFormValidation } from "../../utils";
import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { toast } from "react-toastify";
import { useNavigate, useSearchParams } from "react-router-dom";

const ResetPassword = () => {
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const formConfig = [
    {
      name: "password",
      type: "password",
      label: "Enter New Password",
      placeholder: "Password",
      required: true,
    },
  ];
  const resetPasswordHandler = () => {
    const isValid = handleFormValidation(formConfig, setErrors, formData);
    if (isValid) {
      invokeApi(
        HTTP_METHODS.POST,
        `${HOSTNAME}${REST_URLS.RESET_PASSWORD}`,
        formData,
        { token: searchParams.get("token") }
      )
        .then((res) => {
          if (res.message) {
            toast.error(res.message);
          } else {
            toast.info("Password Reset Successfully");
            setFormData({});
            navigate("/");
          }
        })
        .catch((err) => console.error(err));
    }
  };
  return (
    <div className="forgot-pass-con">
      <div className="content-con">
        <Typography variant="h5" sx={{ fontWeight: 600, textAlign: "center" }}>
          Reset Password
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: "gray", textAlign: "center", mt: 1 }}
        >
          Create your new password
        </Typography>
        <Box
          sx={{
            width: { md: "70%", xs: "100%", sm: "100%" },
          }}
        >
          <FormGenerator
            config={formConfig}
            formData={formData}
            setFormData={setFormData}
            errors={errors}
            setErrors={setErrors}
            fieldGridSize={12}
          />
          <Button
            variant="contained"
            fullWidth
            sx={{ mt: 2 }}
            onClick={resetPasswordHandler}
          >
            Reset Password
          </Button>
        </Box>
      </div>
    </div>
  );
};

export default ResetPassword;
